//Models
PJQ.models.bidForms.Proposal = PJQ.models.bidForms.GroupBidForm.extend({
    idAttribute: "proposalId",
    afterInit: function () {
        this.on('change:isSubmitted', function () {
            if (this.bidder && this.bidder.collection)
                this.bidder.collection.trigger('change');
        });
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'proposals',
                    value: this.id
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'bidForms',
                    value: this.get('bidFormId')
                },
                {
                    endpoint: 'proposals'
                }
            ])
        }
    },
    beforeConstruct: function (attributes) {
        this.lineItems = new PJQ.collections.bidForms.ProposalLineItems([], {bidFormId: attributes.bidFormId });
        this.alternates = new PJQ.collections.bidForms.Alternates([], {bidFormId: attributes.bidFormId});
        this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
        this.attachments = new PJQ.collections.bidForms.Attachments([], {bidFormId: attributes.bidFormId});
        this.projectProposal = new PJQ.models.bidForms.ProjectProposal({});
        this.submittedBy = new PJQ.models.bidForms.Bidder({});
        if (attributes.managedBy) {
            this.managedBy = new PJQ.models.contacts.Contact(attributes.managedBy);
        } else {
            this.managedBy = null;
        }
    },
    parse: function (proposal) {
        if (proposal.bidPackage != null) {
            this.bidPackage = new PJQ.models.bidPackages.BidPackage(proposal.bidPackage);
        } else {
            this.bidPackage = null;
        }

        if (proposal.lineItems) {
            this.lineItems.reset(proposal.lineItems);

            _.each(this.lineItems.models, function (lineItem) {
                lineItem.comments = new PJQ.collections.bidForms.ProposalLineItemComments(lineItem.get('comments'), { lineItem: lineItem });
            });
        }

        if (proposal.alternates) {
            this.alternates.reset(proposal.alternates);

            _.each(this.alternates.models, function (alternate) {
                alternate.comments = new PJQ.collections.bidForms.ProposalAlternateComments(alternate.get('comments'), { alternate: alternate });
            });
        }

        if (_.size(proposal.acknowledgements) > 0) {
            this.acknowledgements.reset(proposal.acknowledgements);
        }

        if (proposal.bidPackageId > 0 && proposal.bidPackage) {
            this.bidPackage = new PJQ.models.bidPackages.BidPackage(proposal.bidPackage)
        }

        this.attachments.reset(proposal.attachments);
        this.projectProposal.parse(proposal.projectProposal);
        if (proposal.submittedBy != null) {
            this.submittedBy = new PJQ.models.bidForms.Bidder(proposal.submittedBy);
        }
        if (proposal.managedBy) {
            this.managedBy = new PJQ.models.contacts.Contact(proposal.managedBy);
        } else {
            this.managedBy = null;
        }

        return proposal;
    },
    preview: function (collection, opts) {
        if (!opts)
            opts = {};
        opts.model = this;
        opts.collection = collection;
        opts.projectBidForm = this.projectProposal;
        new PJQ.views.bidForms.BidFormPreviewModal(opts);
    },
    getStatusName: function () {
        let notSubNamePref = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.BID_FORM_NOT_SUBMITTED_STATUS_NAME_OVERRIDE);
        let status;
        if (notSubNamePref != null) {
            status = notSubNamePref;
        } else {
            status = 'Not Submitted';
        }
        if (this.get('isAwarded'))
            status = 'Awarded';
        else if (this.get('isRejected'))
            status = 'Rejected';
        else if (this.get('isSubmitted'))
            status = 'Submitted';
        return status;
    },
    getStatusId: function () {
        let status = 0;
        if (this.get('isAwarded'))
            status = 3;
        else if (this.get('isRejected'))
            status = 4;
        else if (this.get('isSubmitted'))
            status = 2;
        return status;
    },
    getStatusColor: function () {
        switch (this.getStatusId()) {
            case 4:
                return '#dc3545';
            case 2:
                return '#2196F3';
            case 3:
                return '#4CAF50';
            case 0:
            default:
                return '#9E9E9E';
        }
    },
    export: function (isExportLeveling, isExportComments) {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.id
            },
            {
                endpoint: 'exportproposal'
            }
        ],[
            {
                parameter: 'leveling',
                value: isExportLeveling
            },
            {
                parameter: 'comments',
                value: isExportComments
            }
        ]));
    },
    updateAttachmentDeleted: function (cid, isDeleted) {
        let attachment = this.attachments.get({cid: cid});
        if (attachment.id == null)
            this.attachments.remove(attachment);
        else
            attachment.set('isDeleted', isDeleted);
    },
    setLocked: function () {
        this.set('isLocked', !this.get('isLocked'));
        this.save();
    },
    reject: function (note) {
        this.set({
            isRejected: true,
            rejectNote: _.size(note) > 0 ? note : null
        });
        this.save();
    },
    updateViewed: function (callback) {
        if (this.get('viewedOn') == null && this.get('submittedOn') != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'proposals',
                        value: this.id
                    },
                    {
                        endpoint: 'viewed'
                    }
                ])
            }).get().done(_.bind(function (data) {
                this.set('viewedOn', data.viewedOn);
                if (typeof callback === 'function') {
                    callback(data.viewedOn);
                }
            }, this)).fail(function () {
            });
        } else {
            if (typeof callback === 'function') {
                callback(null);
            }
        }
    },
    submit: function (isSubmit, callback) {
        this.set({
            isSubmitted: isSubmit,
            rejectNote: null
        })
        _.each(this.bidder.contacts.models, function (contact) {
            contact.set('bidStatus', PJQ.constants.projectContacts.bidStatus.BID_RECEIVED);
        });
        if (this.bidder && this.bidder.collection)
            this.bidder.collection.trigger('change');
        this.save(null, {
            success: callback,
            error: function () {
                //todo: notify error
            }
        });
    },
    award: function (isAward) {
        this.set('isAwarded', isAward);
        _.each(this.bidder.contacts.models, function (contact) {
            contact.set('bidStatus', isAward ? PJQ.constants.projectContacts.bidStatus.AWARDED : PJQ.constants.projectContacts.bidStatus.BID_RECEIVED);
        });
        if (this.bidder && this.bidder.collection)
            this.bidder.collection.trigger('change');
        this.save();
    },
    beforeSave: function () {
        _.each(this.lineItems.models, function (lineItem) {
            lineItem.set('comments', lineItem.comments.models);
        });
        _.each(this.alternates.models, function (alternate) {
            alternate.set('comments', alternate.comments.models);
        });
        this.set('lineItems', this.lineItems.toJSON());
        this.set('alternates', this.alternates.toJSON());
        this.set('acknowledgements', this.acknowledgements.toJSON());
        this.set('attachments', this.attachments.toJSON());
        this.projectProposal.beforeSave();
        this.attributes.projectProposal = this.projectProposal.attributes;
    }
});

PJQ.models.bidForms.ProjectProposal = PJQ.models.bidForms.Proposal.extend({
    beforeConstruct: function (attributes) {
        this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
        this.bonding = new PJQ.collections.bidForms.Bonding([], {bidFormId: attributes.bidFormId});
        this.certifications = new PJQ.collections.bidForms.Certifications([], {bidFormId: attributes.bidFormId});
        this.laborRates = new PJQ.collections.bidForms.LaborRates([], {bidFormId: attributes.bidFormId});
    },
    parse: function (proposal) {
        if (proposal) {
            if (_.size(proposal.acknowledgements) > 0) {
                this.acknowledgements.reset(proposal.acknowledgements);
            } else {
                proposal.acknowledgements = this.acknowledgements.toJSON();
            }
            if (_.size(proposal.bonding) > 0) {
                this.bonding.reset(proposal.bonding);
            } else {
                proposal.bonding = this.bonding.toJSON();
            }
            if (_.size(proposal.certifications) > 0) {
                this.certifications.reset(proposal.certifications);
            } else {
                proposal.certifications = this.certifications.toJSON();
            }
            if (_.size(proposal.laborRates) > 0) {
                this.laborRates.reset(proposal.laborRates);
            } else {
                proposal.laborRates = this.laborRates.toJSON();
            }
            this.attributes = _.defaults(proposal, this.attributes ? this.attributes : {});
        }
        return proposal;
    },
    beforeSave: function () {
        this.set('acknowledgements', this.acknowledgements.getChangedModels());
        this.set('bonding', this.bonding.getChangedModels());
        this.set('certifications', this.certifications.getChangedModels());
        this.set('laborRates', this.laborRates.getChangedModels());
    }
});

PJQ.models.bidForms.Attachment = PJQ.models.files.File.extend({
    idAttribute: "proposalAttachmentId"
});

PJQ.models.bidForms.ProposalLineItem = PJQ.models.bidForms.LineItem.extend({
    beforeConstruct: function (attributes) {
        this.comments = new PJQ.collections.bidForms.ProposalLineItemComments([], { lineItem: this });
    }
});

PJQ.models.bidForms.ProposalLineItemComment = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.get('proposalId')
            },
            {
                endpoint: 'lineitems',
                value: this.get('proposalLineItemId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ])
    },
    defaults: {
        comment: "",
        createdBy: 0,
        createdByDisplay: ""
    }
});

PJQ.models.bidForms.ProposalAlternateComment = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.get('proposalId')
            },
            {
                endpoint: 'alternates',
                value: this.get('proposalAlternateId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ])
    },
    defaults: {
        comment: "",
        createdBy: 0,
        createdByDisplay: ""
    }
});

//Collections
PJQ.collections.bidForms.Proposals = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.Proposal,
    endpoint: function () {
        if (this.options.contactId && (!this.options.bidFormId)) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'proposals'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'bidforms',
                    value: this.options.bidFormId
                },
                {
                    endpoint: 'proposals'
                }
            ]);
        }
    },
    getLowestProposal: function (isIncludeAlternates) {
        let sortedProposals = _.sortBy(this.getSubmittedProposals(), function (model) {
            return model.calculateTotal(isIncludeAlternates)
        });
        return sortedProposals.length > 0 ? sortedProposals[0] : null;
    },
    getSubmittedProposals: function () {
        return _.filter(this.models, function (proposal) {
            return proposal.get('isSubmitted')
        });
    }
});

PJQ.collections.bidForms.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.bidForms.Attachment
});


PJQ.collections.bidForms.ProposalLineItems = PJQ.collections.bidForms.LineItems.extend({
    model: PJQ.models.bidForms.ProposalLineItem
});

PJQ.collections.bidForms.ProposalLineItemComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.ProposalLineItemComment,
    endpoint: function(urlOptions) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.options.lineItem.get('proposalId')
            },
            {
                endpoint: 'lineitems',
                value: this.options.lineItem.get('proposalLineItemId')
            },
            {
                endpoint: 'updatecomments'
            }
        ])
    }
});

PJQ.collections.bidForms.ProposalAlternateComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.ProposalAlternateComment,
    endpoint: function(urlOptions) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.options.alternate.get('proposalId')
            },
            {
                endpoint: 'alternates',
                value: this.options.alternate.get('proposalAlternateId')
            },
            {
                endpoint: 'updatecomments'
            }
        ])
    }
});